<!--
    Component: APIErrorsViewer
    This component shows a list all error returned by the API
    Props:
        errors: A array of errors, format: {key_error: "Message error", ...}
    Show only messages
-->
<template>
    <div v-if="generatorErrors">
        <v-alert :value="true" color="error" icon="warning" outline>
            <ul class="alert alert-danger">
                <li v-for="(value, index) in generatorErrors" :key="index">{{ value }}</li>
            </ul>
        </v-alert>
    </div>
</template>

<script>
    export default {
        name: "ApiErrorsViewer",
        props: ['errors'],
        computed: {
            generatorErrors(){
                let errors = this.errors;
                if(errors === '')return ['']
                if (errors.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    if(errors.response.status === 422) {
                        //Validation errors
                        let validationErrors = Object.values(errors.response.data);
                        validationErrors = validationErrors.flat();
                        return validationErrors;
                    }else if(errors.response.status === 403){
                        return [this.$t('forbidden_message')]
                    }else{
                        return [errors.toString()]
                    }
                }else {
                    return [errors.toString()]
                }
            }
        },
        data(){
            return {}
        }
    }
</script>

<i18n>
    {
        "en": {
            "forbidden_message": "You have not permission for the required action"
        },
        "es": {
            "forbidden_message": "Usted no tiene permisos para la accion requerida"
        }
    }
</i18n>